import React from 'react';
import { Box, List, ListItem, Skeleton } from '@mui/material';

const ITEM_COUNT = 8;
interface SemanticQueryCardSkeletonProps {
  item_count?: number;
}
export const SemanticQueryCardSkeleton: React.FC<
  SemanticQueryCardSkeletonProps
> = ({ item_count = ITEM_COUNT }) => {
  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        borderRadius: 2,
        overflow: 'hidden',
        width: '100%',
      }}
    >
      <List>
        {Array.from({ length: item_count }).map((_, i) => (
          <Box key={i}>
            <ListItem
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                px: 2,
                py: 2,
              }}
            >
              {/* Icon */}
              <Skeleton
                variant="rounded"
                width={38}
                height={38}
                sx={{ borderRadius: 2, flexShrink: 0 }}
              />

              {/* Text block */}
              <Box
                sx={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Skeleton variant="text" width="65%" height={16} />
                <Skeleton
                  variant="text"
                  width="100%"
                  height={40}
                  sx={{ mt: -0.5 }}
                />
                {/* Chip */}
                <Skeleton
                  variant="rounded"
                  width={100}
                  height={16}
                  sx={{ borderRadius: 6, mt: 0.5 }}
                />
              </Box>

              {/* Chevron arrow */}
              <Skeleton
                variant="rounded"
                width={20}
                height={20}
                sx={{ flexShrink: 0, mt: -0.5 }}
              />
            </ListItem>
          </Box>
        ))}
      </List>
    </Box>
  );
};
